"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createPNG(image) {
    if (image.components.length !== 1) {
        throw new Error("Not supported!");
    }
    var component = image.components[0];
    if (component.type === "binaryimage" && component.format === "png") {
        return component.data;
    }
    throw new Error("Not supported!");
}
exports.createPNG = createPNG;
//# sourceMappingURL=png-export-image.js.map